/* eslint-disable */
export default {
  flash: {
    error: {
      expiredAuthError: "Your session has expired, <a href='javascript:window.location.reload();'>reload?</a>",
    },
  },
  addToCart: 'Add to Cart',
  addToCartButton: {
    addToCart: 'Add to Cart',
    preorder: 'Preorder',
    preorderEstimatedShipDate: 'Estimated ship date: {{date}}'
  },
  affirmEstimateCTA: {
    asLowAsWith: 'As low as {{tagOpen}}{{price}}/month{{tagClose}} with',
    splitPay: 'or 4 interest-free payments of {{price}} with',
    tooltipText: 'Click to expand offer details',
    zeroPercent: '– from 0% APR.',
    affirmLogo: 'Affirm Logo',
  },
  affirmEstimateSmall: {
    asLowAs: 'As low as {{tagOpen}}{{price}}/mo{{tagClose}}',
    splitPay: 'or 4 interest-free payments of {{price}}',
  },
  affirmEstimateModal: {
    learnMore: 'Learn more',
    finePrint: 'Subject to credit check and approval. Down payment may be required. For purchases under $100, limited options are available. Estimated payment amount excludes taxes and shipping fees. Affirm loans are made by Cross River Bank, a New Jersey State Chartered Commercial Bank, Member FDIC. See {{linkOpen}}www.affirm.com/faqs{{linkClose}} for details',
    moreOfferDetails: 'Buy now, pay over time.',
    quickAndEasyTitle: 'Quick and easy',
    quickAndEasyDescription: 'Enter a few pieces of information for a real-time decision. Checking your eligibility won’t affect your credit score.',
    noHiddenFeesTitle: 'No Hidden Fees',
    noHiddenFeesDescription: 'Know up front exactly what you’ll owe, with no hidden costs and no surprises.',
    atCheckout: 'Just select {{logoOpen}}{{logoClose}} at checkout',
    offerDetails: '{{monthlyCost}}/month based on a purchase price of {{price}} at {{estimateAprPercent}}% APR for {{maxMonths}} months. Excludes tax and shipping fees, to be calculated at checkout. Rates range from {{bestPercent}}-30% APR.',
    splitPayOfferDetails: 'Four interest-free payments of {{paymentAmount}} based on a purchase price of {{price}}. Excludes tax and shipping fees, to be calculated at checkout.',
    zeroFinancing: {
      moreOfferDetails: 'Make easy payments over {{months1}}, {{months2}}, or {{months3}} months.',
      nudgeTitle: 'Buy now, pay later – from 0% APR',
    },
  },
  alertBox: {
    dismiss: 'Dismiss'
  },
  dismissibleSidebar: {
    close: 'Close',
  },
  listingRow: {
    similarListingsUK: 'Similar Gear from UK Sellers',
  },
  auction: 'Live Auction',
  shipping: 'Shipping',
  shippingTo: 'Shipping to',
  freeShipping: 'Free Shipping',
  acceptsOffers: 'Accepts Offers',
  localPickupOnly: 'Local Pickup Only',
  plusShipping: '+ Shipping',
  estimatedMonthlyPaymentCallout: 'As low as {{displayPrice}}/mo',
  expeditedShippingAvailable: '2-Day Shipping available',
  freeExpeditedShipping: 'Free 2-Day Shipping',
  freeExpeditedShippingInfo: "Ships within one business day via a 2-day delivery service. Not available with offers or 0% financing",
  whenYouCombineShipping: 'shipping when combined',
  howToCombinedShippingTooltip: 'Discount applied when purchased with another item from this shop that has a greater shipping cost (or if you buy multiple)',
  freeBecauseThreshold: 'Free because you met this shop’s free shipping threshold!',
  calculateShipping: 'Calculate shipping',
  calculateShippingChange: 'Change',
  unavailableTo: 'Shipping unavailable to',
  closeButton: {
    defaultLabel: 'close',
  },
  collapsingFacets: {
    collapse: 'Collapse',
    showMore: 'Show More',
  },
  collapsingList: {
    collapse: 'Collapse',
    showMore: 'Show More',
  },
  free: 'Free',
  priceDisplayRangeSeparator: ' - ',
  ribbonView: {
    bidNow: 'Bid Now',
  },
  formGroup: {
    optional: 'Optional',
    recommended: 'Recommended',
    required: 'Required',
    requiredError: 'This field is required'
  },
  lightboxImage: {
    closeButton: 'Close',
  },
  next: 'Next',
  nextImage: 'Next image',
  paginationGap: 'Pagination Gap',
  previous: 'Previous',
  previousImage: 'Previous image',
  sanitizedRender: {
    collapse: 'collapse',
    expand: 'read more',
    expandEllipsis: 'read more…'
  },
  selectFormGroup: {
    selectOne: 'Select one…',
  },
  sellYoursButton: 'Sell Yours',
  shopBadges: {
    preferredSeller: 'Preferred Seller',
    preferredSellerDescription: 'This seller provides outstanding service',
    quickResponder: 'Quick Responder',
    quickResponderDescription: 'This seller responds quickly to messages',
    quickShipper: 'Quick Shipper',
    quickShipperDescription: 'On average, this seller ships quickly',
  },
  watchBadge: {
    watch: 'Watch',
    unwatch: 'Watching',
    watchers: {
      one: '{{count}} Watcher',
      other: '{{count}} Watchers',
    },
    benefits: {
      signUp: 'Join Reverb to Watch This Listing',
      priceDrop: 'We\'ll notify you if the price drops',
      offers: 'We\'ll notify you if anyone else makes an offer',
    }
  },
  watchRow: {
    title: 'From Your Watch List',
    cta: 'Your Watch List',
  },
  currency: {
    unsupportedCurrencyConversion:
      'Conversion between from currency {{fromCurrency}} and to currency {{toCurrency}} is not supported',
  },
  auctionForm: {
    bidNow: 'Bid Now',
    ended: 'Ended',
    increaseBid: 'Increase Bid',
    inputPlaceholder: 'Bid amount ...',
    viewAuction: 'View Auction',
    outbid: "You've been outbid",
  },
  auctionStatus: {
    LOSING: "You're being outbid!",
    WINNING: "You're winning!",
    WON: "You've won!",
  },
  auctionHelpers: {
    bidSummary: {
      amount: 'Bid at least {{amount}}',
      currentBid: 'Your current max bid is {{display}}',
    },
    errors: {
      bidMustBeHigherThanMinimum:
        'Your bid must be higher than the current minimum bid of {{formattedBidMinimum}}.',
      bidMustBeHigherThanYourCurrentMax:
        'Your new bid must be higher than your current max bid of {{currentMax}}.',
    },
    priceSummary: {
      startingBid: 'Starting Bid',
      currentBid: 'Current Bid',
    },
    timeSummary: {
      endsAt: 'Ends {{date}}',
      endedAt: 'Auction ended {{date}}',
      startsAt: 'Bidding begins {{date}}',
    },
  },
  modalDialog: {
    goBack: 'Go back',
    save: 'Save Changes',
    delete: 'Delete',
    wait: 'Please wait...',
  },
  addFollowToFeed: {
    addToGearAlerts: 'Also add this to my Daily Feed email',
    removeFromGearAlerts: 'Remove from my Daily Feed email',
    followSearch: 'View all matching listings',
    remove: {
      removeFromFeed: 'Remove from feed',
      areYouSure: 'Are you sure?',
      confirm: 'Yes',
      cancel: 'No',
      removeHint: "Matching items will be removed from your feed and we won't add any new ones.",
    },
  },
  bumpsView: {
    header: 'Reverb Bump',
  },
  regionFilterOptions: {
    loadPlaceholder: 'Change',
  },
  searchControls: {
    used: 'Used',
    new: 'Brand New',
  },
  modal: {
    backAction: 'Go back',
  },
  gridCardRow: {
    sellerRating: 'Seller Rating',
    moreInfo: 'More Info',
    viewListing: 'View Listing',
  },
  offers: {
    action: {
      create: 'Make an Offer',
      counter: 'Counter',
      accept: 'Accept',
      reject: 'Decline',
    },
    backAction: 'Cancel',
    originalPrice: 'List price: {{price}}',
    submitOfferButton: 'Submit Offer',
    submitOfferButtonWithAmount: 'Submit Offer for {{offerTotal}}',
    taxFootNoteHtml: '* Sales tax may be applied during checkout. {{tagOpen}}Learn More{{tagClose}}',
    offerCount: {
      one: '{{count}} Offer',
      other: '{{count}} Offers',
    },
    offerTipLowball: 'Many sellers will reject an offer that low.',
    offerTipHighball: "You're offering more than the asking price. Is that correct?",
    percentOff: '{{percent}}% Off',
    amountWithPercentOff: '{{displayAmount}} ({{percent}}% Off)',
    recommendedDropExplainer: 'Recommendation based on recent sales for the same item in {{conditionName}} condition.',
    quickOffers: 'Quick offers:',
    recommendedOffer: 'Recommended offer:',
    nudgeHeaderLowball: 'Buying Tip',
    nudgeHeaderHighball: 'Heads Up!',
    nudgeDisclaimerLowball: 'Based on past transaction data, a higher offer has a better chance of being accepted.',
    nudgeDisclaimerHighball: 'Your offer is higher than the listing price. Are you sure you want to offer {{tagOpen}}{{amount}}{{tagClose}}?',
    currencyApproximation: 'Your offer: {{offerAmount}} + {{shippingPrice}} Shipping',
    currencyApproximationUnknownShipping: 'Your offer: {{offerAmount}} + Shipping',
    sellerCurrencyWarning: "This seller receives offers in {{shopCurrency}}. What you'll pay in {{userCurrency}} may vary slightly based on exchange rates.",
    valueMayVary: 'The equivalent value in {{userCurrency}} may vary',
    offerQuantity: 'Quantity',
    saleNotice: 'Sale discounts do not apply to offers',
    freeTwoDayShippingNotice: 'Free 2-Day shipping does not apply to offers',
    combinedSaleShippingNotice: 'Sale discounts and free 2-Day shipping do not apply to offers',
    timeline: '{{shopName}} has 24 hours to reply.',
    salesTaxMayBeApplied: 'Sales tax may be applied during checkout. See %{linkOpen}Shop Policies%{linkClose} for details.',
    shippingPrice: '+ {{shippingPrice}} Shipping',
    label: {
      counterPrice: 'Your Counter Offer',
      initialPrice: 'Your Best Offer',
      shipping: 'Shipping Price',
    },
    sellerMessageLabel: 'Message to Buyer',
    buyerMessageLabel: 'Message to Seller',
    terms: 'I agree to pay if my offer is accepted',
    termsWithTax: 'I agree to pay if my offer is accepted, including all applicable taxes',
    location: {
      shippingTo: 'Shipping to {{regionName}}, {{postalCode}}',
      change: 'Change',
      shippingRegionLabel: 'Shipping Region',
      postalCodeLabel: 'Shipping Postal/ZIP Code',
      localPickupDetails: 'Local Pickup in {{location}}',
      noShippingCostSet: 'The seller has not set a shipping cost for this region',
    },
    cancel: 'Cancel',
    error: "We're sorry, something went wrong. Please try again.",
    seller: 'seller',
    buyer: 'buyer',
    initialSubmissionSuccess:
      "Your offer of {{amount}} has been submitted. You'll hear from the {{otherParty}} soon.",
    sidebar: {
      condition: 'Condition',
      shipping: 'Shipping',
      viewListing: 'View Listing',
      shopDisplayLocation: 'Ships From',
      sellerCost: 'Your Cost',
      askingPrice: 'Asking Price',
      listPrice: 'List Price',
      priceWithTaxIncludedHint: '{{displayPrice}} ({{taxIncludedHint}})',
      watches: 'Watches',
    },
    benefits: {
      title: 'Sign Up to Make an Offer',
      saveMoney: 'Save 10-15% on average',
      quickResponse: 'Most sellers respond within 4 hours',
    },
    autoOffers: 'Direct Offers'
  },
  shippingRegionSelector: {
    everywhereElse: 'Rest of the World',
    label: 'Select a region or country',
  },
  subRegions: {
    US_CON: 'Continental U.S.',
    US_AK: 'Alaska',
    US_HI: 'Hawaii',
    US_PR: 'Puerto Rico',
    US_OTHER: 'Other U.S. Territories',
  },
  signupForm: {
    signupHeader: 'Create a Reverb Account',
    signinHeader: 'Log in to Reverb',
    firstNameLabel: 'First name',
    lastNameLabel: 'Last name',
    emailLabel: 'Email',
    emailValidationError: 'Please enter a valid email address.',
    emailConfirmLabel: 'Email Confirmation',
    emailMatchError: 'Emails must match',
    passwordLabel: 'Password',
    passwordTip: '(at least {{minLength}} characters)',
    showPassword: 'Show Password',
    hidePassword: 'Hide Password',
    newsletterLabel: 'Yes, send me exclusive offers, promotions, news, reviews, and personalized tips for buying and selling on Reverb.',
    acceptTermsLabel:
      'By clicking Sign Up, I expressly agree to accept Reverb’s {{termsLinkOpen}}Terms of Use{{linkClose}} and {{privacyLinkOpen}}Privacy Policy{{linkClose}',
    gdprAcceptTermsLabel:
      'By clicking Sign Up, I expressly agree to accept Reverb’s {{termsLinkOpen}}Terms of Use{{linkClose}} and {{privacyLinkOpen}}Privacy Policy{{linkClose}}, including the processing of my personal data for access to the Reverb Marketplace and for Reverb ads.',
    gdprHowReverbUsesData: 'How Reverb Uses Data',
    gdprReverbProcessesData:
      'Reverb processes your data to provide you with access to its marketplace as a buyer, seller, or both, or as a developer utilizing the API or creating Applications. To learn about changing your data processing settings, visit our {{gdprPolicyLinkOpen}}policy page{{linkClose}}.',
    signUp: 'Sign Up',
    logIn: 'Log In',
    facebookSignup: 'Sign Up with Facebook',
    facebookSignin: 'Log In with Facebook',
    appleSignUp: 'Sign Up with Apple',
    appleSignIn: 'Log In with Apple',
    appleImgAltText: 'Apple Logo',
    rememberMe: 'Stay signed in',
    forgotPassword: 'Forgot your Password?',
    passwordReset: 'Reset it',
    alreadyHaveAccount: 'Already have an account?',
    dontHaveAccount: "Don't have an account yet?",
  },
  dynamicPage: {
    pageEditLink: 'Edit This Page',
    footerByline: 'Editorial content by {{author}}',
  },
  dynamicPageHead: {
    searchPlaceholder: 'Search',
    actionText: 'View All Listings',
  },
  notFound: {
    pageTitle: 'Not Found',
    title: "Sorry, this page isn't available.",
    description: 'The link you followed may be broken or the page may have been deleted.',
    returnHome: 'Return Home',
  },
  propertySwitcher: {
    core: 'Reverb',
    lp: 'Reverb LP',
  },
  errorDisplay: {
    header: 'Oops',
    message: 'Something went wrong. Please try again.',
  },
  cspModule: {
    estimatedValue: 'Price Guide Estimated Value',
    usedFrom: '{{count}} used from {{price}}',
    newFrom: '{{count}} new from {{price}}',
    buyNewFrom: 'Buy New from {{price}}',
    seePriceGuide: 'See chart & recent transactions',
    fromPriceGuide: 'From the Price Guide',
    findMore: 'Find More on Reverb',
    fairMarketValue: 'Fair Market Value',
    lowToHighPrice: '{{low}} - {{high}}'
  },
  cspPgCard: {
    lowestFrom: 'Browse {{count}} options from {{price}}',
    productFamily: 'Explore {{name}}',
  },
  quantitySelector: {
    inStock: '{{count}} in stock',
    atMaxBuyerQuantity: ' (limit {{maxBuyerQuantity}} per order)',
    availableForPreorder: '{{count}} available for preorder',
  },
  nudgeManager: {
    negotiate: 'This seller is open to offers',
    saveMoney: 'Save 10-15% on average',
    watchNudge: 'Watch this listing to get price drop alerts',
  },
  specList: {
    condition: 'Condition',
    conditionNew: '{{name}} (New)',
    conditionUsed: '{{name}} (Used)',
    learnMore: 'learn more',
    conditions: {
      'brand-new': 'Brand New items are sold by an authorized dealer or original builder and include all original packaging.',
      'b-stock': 'B-Stock items are sold by an authorized dealer or original builder, but have been opened, blemished, or used in some manner.',
      'like-new': 'Like New items are in essentially new original condition but have been opened or played.',
      mint: 'Mint items are in essentially new original condition but have been opened or played.',
      'mint-inventory': 'Mint items are in essentially new original condition but have been opened or played.',
      excellent: 'Excellent items are almost entirely free from blemishes and other visual defects and have been played or used with the utmost care.',
      'very-good': 'Very Good items may show a few slight marks or scratches but are fully functional and in overall great shape.',
      good: 'Good condition items function properly but may exhibit some wear and tear.',
      fair: 'Fair condition gear should function but will show noticeable cosmetic damage or other issues.',
      poor: 'Poor condition gear may not work properly but can still perform most functions.',
      'non-functioning': 'Non-functioning items do not work as they should. All known issues should be described in the listing description.',
    },
    listed: 'Listed',
  },
  newsletterSignup: {
    heading: "Join the Musician's Marketplace",
    cta: 'Sign Up',
    headingNewsletter: 'Yes! Send me exclusive offers & promotions, news & reviews, and personalized tips for buying and selling on Reverb.',
    ctaNewsletter: 'Subscribe',
    placeholder: 'Your Email',
    gdprTerms: 'By clicking %{buttonText}, I agree to receive exclusive offers & promotions, news & reviews, and personalized tips for buying and selling on Reverb.',
    terms: 'By clicking %{buttonText}, I agree to receive exclusive offers & promotions, news & reviews, and personalized tips for buying and selling on Reverb.',
    successTitle: 'Thanks for signing up!',
    successMessage: 'Stay tuned for the latest from Reverb.',
    errorMessage: 'Sorry, something went wrong. Try again in a minute.',
    invalidEmailMessage: 'Please enter a valid email address.',
  },
  searchHeader: {
    pickUp: 'Pick up where you left off',
    needInspiration: 'Need inspiration? Try one of these',
    suggestion: 'Try {{tagOpen}}"{{suggestion}}"{{tagClose}}',
    placeholder: 'Search the marketplace…',
    title: 'Find Your Dream Gear',
    subtitle: 'Join the millions of music lovers who use Reverb to find everything they need to make music',
    loggedInSubtitle: 'New music gear from trusted brands, small businesses, and music makers just like you added daily.',
    suggestions: {
      fenderStratocaster: '1964 Fender Stratocaster',
      elektronDigitakt: 'Elektron Digitakt',
      fenderPrecisionBass: 'Fender Precision Bass',
      lesPaulCustom: 'Gibson Les Paul Custom',
      tubeScreamer: 'Ibanez Tube Screamer',
      ludwigBlackBeauty: 'Ludwig Black Beauty Snare',
      ludwigJazzFestival: 'Ludwig Jazz Festival Snare',
      MarshallJcm800: 'Marshall JCM800',
      moogModelD: 'Moog Model D Synthesizer',
      neumannU87: 'Neumann U 87',
      procoRat: 'ProCo Rat',
      rolandJuno106: 'Roland Juno 106',
      sureSm7b: 'Shure SM7B Microphone',
      strymonTimeline: 'Strymon TimeLine',
      taylorGsMini: 'Taylor GS Mini',
      teenageEngineeringOp1: 'Teenage Engineering OP-1',
      apolloTwin: 'Universal Audio Apollo Twin',
      voxAc30: 'Vox AC30',
      yamahaDx7: 'Yamaha DX7',
      zildjianNewBeat: 'Zildjian New Beat Hi-Hats',
    },
  },
  messageSeller: 'Message Seller',
  listingNudge: {
    inOtherCarts: {
      one: 'In {{count}} Other Cart',
      other: 'In {{count}} Other Carts',
    },
  },
  conditionDisplay: {
    used: `Used – {{condition}}`,
  },
  listingCard: {
    location: {
      sameCountry: '{{city}}',
      sameCountryUs: '{{city}}, {{state}}',
      otherCountry: '{{city}}, {{country}}',
    },
  },
  listingCardNudge: {
    freeExpeditedShipping: 'Free 2-Day Shipping',
    freeShipping: 'Free Shipping',
    greatValue: 'Great Value',
    inOtherCarts: 'In {{count}} Other Carts',
    localPickup: 'Local Pickup',
    localPickupAvailable: 'Local Pickup Available',
    returnPolicy: '{{returnPolicyDays}}-Day Return Policy'
  },
  subwayNavigation: {
    dropdownTitle: 'Step {{currentStepNumber}} of {{totalSteps}}',
    step: {
      currentStep: 'Current Step',
      currentStepWithErrors: 'Current Step - Has Errors',
      completedStep: 'Completed Step',
      stepWithErrors: 'Step with errors',
      futureStep: 'Future Step',
    },
  },
  richTextEditor: {
    styleButton: {
      bold: 'Toggle Bold',
      italic: 'Toggle Italic',
      underline: 'Toggle Underline',
      bulletedList: 'Toggle Bulleted List',
    },
    adminOnlyButton: 'HTML (admin only)',
  },
  starRating: {
    ratingText: '{{rating}} out of 5 stars',
  },
  starRatingSelector: {
    optionText: {
      one: '1 Star',
      other: '{{count}} Stars',
    },
  },
  truncationContainer: {
    showMore: 'Show More',
  },
  proximityFilter: {
    filterName: 'Within {{distance}} Miles',
    filterNameWithZip: 'Within {{distance}} Miles of {{postalCode}}',
    modalButton: 'Change',
    modalDistanceMiles: '{{distance}} Miles',
    adjustLocation: 'Adjust Location',
    zipCode: 'Zip Code',
    radius: 'Radius',
    editZipCode: 'Edit Zip Code',
    update: 'Update',
  },
  photoUploader: {
    thumb: {
      edit: 'Edit',
      alt: 'Uploaded Image {{index}}',
      remove: 'Remove',
      tooSmallWarning: 'Image is too small',
      sortableAlt: 'Toggle reordering for this image',
      primaryLabel: 'Primary',
    },
    thumbList: {
      photos: 'Photos',
      reorder: 'Reorder',
      done: 'Done',
    },
    editor: {
      rotate: 'Rotate',
      crop: 'Crop',
      cancel: 'Cancel',
      done: 'Done',
      save: 'Save',
      imageAlt: 'Image Preview',
      header: 'Edit Photo',
      removePhoto: 'Remove Photo',
    },
    tip: {
      header: 'Upload or drag and drop photos of your gear.',
      reorder: 'You can drag your images to reorder them - the upper left image will be the primary photo.',
      details: 'Use original photos for used gear. Screenshots of pictures from other sites, sellers, or manufacturers are not allowed. Square photos are best, and they should be at least 620 by 620 pixels.',
    },
    fileUploader: {
      uploadPhoto: 'Upload Photo',
      dragAndDrop: {
        noLimit: 'Or drag and drop your files here',
        withLimit: 'Or drag and drop up to {{count}}',
      },
    },
    alert: {
      uploadFailure: {
        message: 'There was a problem uploading your image. Please make sure your image is a .jpg, .png or .heic format and try again.'
      },
      smallImageError: {
        message: 'An image was removed because it was too small. Listings look best with images that are at least 620 pixels on each side. Please upload a larger image.',
      },
      smallImageWarning: {
        message: 'Some of your images are a bit small. The best listing images are at least 620 pixels on each side.',
      },
      photoLimitReached: {
        message: "You've reached the limit of {{count}} photos."
      },
      photoLimitExceeded: {
        message: "Some photos weren't uploaded because you've reached the maximum allowed limit."
      },
    }
  },
  marketplaceFilters: {
    allFilters: 'All Filters',
    filterAndSort: 'Filter & Sort',
    filterYourSearch: 'Filter Your Search',
    viewResults: 'View Results',
    resultsCount: '{{count}} Results',
    resultsCountFor: '{{count}} Results for {{children}}',
    allConditions: 'New & Used',
    allBrands: 'Brand',
    allDecades: 'Decade',
    clearFilters: 'Clear Filters',
    allFinishes: 'All Finishes',
  },
  marketplaceViewStates: {
    list: 'List',
    grid: 'Grid',
  },
  adCallout: 'Ad',
  sponsoredContentPartner: 'In Partnership With {{partner}}',
  sellerLocationSearchFilter: {
    buttonText: 'Seller Location',
  },
  forms: {
    clearLabel: 'Clear',
    submitLabel: 'Submit',
  },
  appStoreBadge: {
    storeBadgeAltApple: 'Download on the Apple App Store',
    storeBadgeAltGoogle: 'Download on the Google Play Store',
  },
  mobileAppCallout: 'Download the Reverb App',
  mobileAppAd: {
    appIllustrationAlt: 'Sketch of Reverb Mobile App',
  },
  shopLocal: {
    title: 'Shop Local',
    tooltip: 'Find deals in your neighborhood and save on shipping with local pickup.',
    learnMore: 'Learn more',
  },
  pill: {
    add: "Add",
    remove: "Remove",
  },
  loadingBars: {
    label: 'Loading',
  },
  sellerBadgeStatus: {
    completed: '{{completed}}/{{total}} Completed',
    showRequirements: 'Show Requirements',
    hideRequirements: 'Hide Requirements',
    stepNumberCompleted: 'Step {{number}} Completed.',
  },
  contentSponsorship: {
    ad: 'Ad',
    partnership: 'In Partnership With {{partner}}',
  },
  priceWithShipping: {
    newPrice: 'New Price',
    originalPrice: 'Original Price',
    price: 'Price',
  },
  totalPrice: {
    tooltip: "Use this to account for a listing's total cost when filtering and sorting by price."
  },
  homepage: {
    categorySearch: {
      search: "Search {{category}}",
      ifItsMusicGear: "If it's music gear, it's here.",
      searchMarketplace: "Shop new and used musical instruments from local shops, your favorite brands, and music makers like you.",
      findGear: "Find gear you love from more than 200,000 sellers.",
      sellGear: "Sell your gear",
      turnIntoNew: "{{children}} easily to millions of music makers.",
      electricGuitars: 'Electric Guitars',
      bassGuitars: 'Bass Guitars',
      pedals: 'Pedals',
      keysAndSynths: 'Keys and Synths',
      amplifiers: 'Amplifiers',
      drums: 'Drums',
      recordingGear: 'Recording Gear',
      allElectricGuitars: 'All Electric Guitars',
      solidBody: 'Solid Body',
      archtop: 'Archtop',
      vintage: 'Vintage',
      semiHollow: 'Semi-Hollow',
      allBassGuitars: 'All Bass Guitars',
      fretless: 'Fretless',
      leftHanded: 'Left-Handed',
      acoustic: 'Acoustic',
      fourString: '4-String',
      fiveStringAndMore: '5-String and More',
      activeElectronics: 'Active Electronics',
      allPedals: 'All Pedals',
      overdrive: 'Overdrive',
      distortion: 'Distortion',
      fuzz: 'Fuzz',
      delay: 'Delay',
      wah: 'Wah',
      allKeysAndSynths: 'All Keys and Synths',
      eurorack: 'Eurorack',
      modular: 'Modular',
      digital: 'Digital',
      analog: 'Analog',
      rackmount: 'Rackmount',
      allAmplifiers: 'All Amplifiers',
      guitarCombos: 'Guitar Combos',
      guitarHeads: 'Guitar Heads',
      guitarCabinets: 'Guitar Cabinets',
      modelingAmps: 'Modeling Amps',
      allDrums: 'All Drums',
      drumSets: 'Drum Sets',
      snares: 'Snares',
      cymbals: 'Cymbals',
      drumMachinesAndSamplers: 'Drum Machines & Samplers',
      electronicDrumSets: 'Electronic Drum Sets',
      allRecordingGear: 'All Recording Gear',
      microphones: 'Microphones',
      studioMonitors: 'Studio Monitors',
      recordingInterfaces: 'Recording Interfaces',
      mixers: 'Mixers',
      podcastingMics: 'Podcasting Mics',
      mobileRecordingInterfaces: 'Mobile Recording Interfaces',
    }
  }
};
